export const HYPHENATED_LANGUAGES: string[] = ['de'];

export const RTL_LANGUAGES: string[] = ['ar', 'az', 'dv', 'he', 'ku', 'fa', 'ur'];

export const RTL = 'rtl';

export const LTR = 'ltr';
